export const PublicPages = ['login', 'forgotpassword', 'googlelogin', 'resetpassword'];

export const WelcomePathName = 'welcome';
